import { Panel } from '../../ui/Panel';
import { Text } from '../../ui/Text';
import { token, zVar } from '../../ui/theme';

/*
 * Game code display. `CodeChip` is the reusable inline label + code (easy to
 * read aloud or type). `GameCodeBadge` is the fixed top-left placement used
 * pre-game (where GameInfoPanel — which hosts the chip during play — isn't
 * shown), so the table's name and code are always visible for sharing without
 * copying a link.
 */

export const CodeChip = ({ code }: { code: string }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-2)' }}>
    <span
      style={{
        fontSize: 'var(--font-size-xs)',
        letterSpacing: '2px',
        color: token('color-muted'),
      }}
    >
      CODE
    </span>
    <span
      style={{
        fontFamily: 'monospace',
        fontWeight: 700,
        fontSize: 'var(--font-size-md)',
        letterSpacing: '3px',
        color: token('color-gold'),
      }}
    >
      {code}
    </span>
  </span>
);

export const GameCodeBadge = ({ code, title }: { code: string; title?: string }) => (
  <Panel
    variant="hud"
    style={{
      position: 'absolute',
      left: 24,
      top: 8,
      zIndex: zVar('z-hud'),
      padding: '8px 14px',
      maxWidth: 280,
    }}
  >
    {title && (
      <Text
        as="div"
        variant="value"
        style={{
          fontSize: 'var(--font-size-md)',
          marginBottom: 2,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={title}
      >
        {title}
      </Text>
    )}
    <CodeChip code={code} />
  </Panel>
);
